/**
 * Product Recommendations — Shopify native API loader.
 * On the PDP, the section renders a skeleton with a `data-recs-url`.
 * This script fetches that URL (which returns the section HTML with real
 * recommendations) and swaps the section in place.
 */
(function () {
  'use strict';

  const load = (section) => {
    const url = section.dataset.recsUrl;
    if (!url) return;

    fetch(url, { headers: { Accept: 'text/html' } })
      .then((r) => r.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[data-product-recommendations]');
        if (!newSection) {
          // No section found in response — likely no recommendations; hide skeleton.
          section.style.display = 'none';
          return;
        }
        // If the response has no products (no grid), hide.
        const hasProducts = newSection.querySelector('.iurop-product-list__grid .iurop-product-card');
        if (!hasProducts) {
          section.style.display = 'none';
          return;
        }
        section.innerHTML = newSection.innerHTML;
      })
      .catch((err) => {
        console.error('[product-recommendations] fetch failed', err);
        section.style.display = 'none';
      });
  };

  const boot = () => {
    document.querySelectorAll('[data-product-recommendations][data-recs-url]').forEach(load);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on theme editor section reload.
  document.addEventListener('shopify:section:load', (e) => {
    const sections = e.target.querySelectorAll('[data-product-recommendations][data-recs-url]');
    sections.forEach(load);
  });
})();
